var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.000000, -9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.000000, 9.562500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2724601,22.1962899 L11.3886723,15.3125 L18.2724601,8.4287101 C18.6997062,8.00146401 18.6997062,7.30898321 18.2724601,6.88242137 C17.845214,6.45585954 17.1527332,6.45517528 16.7261714,6.88242137 L9.06992137,14.5386724 C8.85937542,14.7519533 8.75,15.0322261 8.75,15.3125 C8.75,15.5927739 8.8567771,15.8722258 9.07046899,16.0856444 L16.726719,23.7418944 C17.1539651,24.1691405 17.8464448,24.1691405 18.2730088,23.7418944 C18.6995727,23.3146483 18.7031254,22.6201168 18.2724601,22.1962899 Z M30.625,26.25 L30.625,4.375 C30.625,1.95849568 28.6665043,0 26.25,0 L4.375,0 C1.95849568,0 0,1.95849568 0,4.375 L0,26.25 C0,28.6665043 1.95849568,30.625 4.375,30.625 L26.25,30.625 C28.6630851,30.625 30.625,28.6630851 30.625,26.25 Z M4.375,28.4375 C3.16914067,28.4375 2.1875,27.4558604 2.1875,26.25 L2.1875,4.375 C2.1875,3.16913962 3.16914067,2.1875 4.375,2.1875 L26.25,2.1875 C27.4558604,2.1875 28.4375,3.16913962 28.4375,4.375 L28.4375,26.25 C28.4375,27.4558604 27.4558604,28.4375 26.25,28.4375 L4.375,28.4375 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/backBtn.6a154b7b28f30bf6f8c2a6c635f402c4.svg";
export { ForwardRef as ReactComponent };